import { ApolloLink, Observable } from "apollo-link";
import { print } from "graphql";

export function createUploadLinkWithProgress({ uri, onProgress }) {
  return new ApolloLink(
    operation =>
      new Observable(observer => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", uri);

        // Apply headers from context
        const context = operation.getContext();
        const headers = context.headers || {};
        Object.keys(headers).forEach(key => {
          xhr.setRequestHeader(key, headers[key]);
        });

        // Track progress
        xhr.upload.onprogress = event => {
          if (event.lengthComputable && typeof onProgress === "function") {
            const percent = Math.round((event.loaded / event.total) * 100);
            onProgress(percent > 0 ? percent - 1 : 0);
          }
        };

        xhr.onload = () => {
          try {
            const json = JSON.parse(xhr.responseText);
            if (xhr.status >= 200 && xhr.status < 300) {
              observer.next(json);
              observer.complete();
            } else {
              observer.error(json);
            }
          } catch (err) {
            observer.error(err);
          }
        };

        xhr.onerror = () => observer.error(new Error("Network error"));

        // Build multipart form data for GraphQL
        const { query, variables } = operation;
        const formData = new FormData();

        formData.append(
          "operations",
          JSON.stringify({
            query: print(query),
            variables
          })
        );

        // Map file uploads
        const map = {};
        let i = 0;
        const appendFiles = (obj, path) => {
          if (obj instanceof File || obj instanceof Blob) {
            map[i] = [path];
            formData.append(String(i), obj);
            i++;
          } else if (obj && typeof obj === "object") {
            Object.entries(obj).forEach(([k, v]) =>
              appendFiles(v, `${path}.${k}`)
            );
          }
        };
        appendFiles(variables, "variables");

        formData.append("map", JSON.stringify(map));

        xhr.send(formData);
      })
  );
}
